import { Text } from '@qwickapps/react-framework';

interface Agent {
  id: string;
  name: string;
  status: 'online' | 'offline' | 'busy';
  currentTask?: string;
  lastSeen?: string;
}

interface AgentStatusCardProps {
  agent: Agent;
}

export default function AgentStatusCard({ agent }: AgentStatusCardProps) {
  const statusColors = {
    online: '#4caf50',
    offline: '#9e9e9e',
    busy: '#ff9800',
  };

  return (
    <div
      style={{
        padding: 16,
        borderRadius: 8,
        background: 'var(--theme-bg-surface)',
        border: '1px solid var(--theme-border-color)',
        minWidth: 200,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: statusColors[agent.status],
          }}
        />
        <Text variant="subtitle1" content={agent.name} />
      </div>

      {agent.currentTask ? (
        <Text
          variant="body2"
          content={agent.currentTask}
          customColor="var(--theme-text-secondary)"
        />
      ) : (
        <Text
          variant="caption"
          content="No active task"
          customColor="var(--theme-text-disabled)"
        />
      )}

      {agent.lastSeen && (
        <Text
          variant="caption"
          content={`Last seen: ${new Date(agent.lastSeen).toLocaleTimeString()}`}
          customColor="var(--theme-text-disabled)"
        />
      )}
    </div>
  );
}
